import type { PlanningAlgorithm } from '../PlanningAlgorithm/PlanningAlgorithm';
import type { ViewsService } from '../app/Views.service';
import type { IRemover } from './Interfaces';
import { TYPES } from '@/engine/ioc';
import { inject, injectable } from 'inversify';

@injectable()
export class Remover implements IRemover {
  private readonly _planningAlgorithm: PlanningAlgorithm;

  private readonly _viewsService: ViewsService;

  public constructor(
    @inject(TYPES.PlanningAlgorithm) planningAlgorithm: PlanningAlgorithm,
    @inject(TYPES.ViewsService) viewsService: ViewsService
  ) {
    this._planningAlgorithm = planningAlgorithm;
    this._viewsService = viewsService;
  }

  // eslint-disable-next-line @typescript-eslint/no-misused-promises -- //TODO: [chebotarev] fix eslint no-misused-promises
  public removeByDescriptor(descriptor: string, attachments: Array<string> = []): Promise<void> {
    const descriptorsToRemove = [descriptor].concat(attachments);
    for (const descriptor of descriptorsToRemove) {
      this._viewsService.removeFromViewsByDescriptor(descriptor);
      // eslint-disable-next-line @typescript-eslint/no-floating-promises -- //TODO: [chebotarev] fix eslint no-floating-promises
      this._planningAlgorithm.dropAlgorithmExtensionAsync(descriptor);
    }
    return Promise.resolve();
  }
}
